export default __webpack_public_path__ + "static/media/closing-img.07190c74.svg";